<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <div>
                    <div class="page-block__overview-link">
                        <customer-router-link :to="{ name: 'users' }" class="link-no-decoration | u-flex-center">
                            <svg width="16" viewBox="0 0 32 32" class="u-margin-right-inline">
                                <use xlink:href="@/assets/arrow.svg#arrow-left"></use>
                            </svg>
                            <strong>{{ trans('page.users.back-to') }}</strong>
                        </customer-router-link>
                    </div>

                    <h1 class="page-block__title | u-font-weight-normal">{{ trans('page.user-create.title') }}</h1>
                </div>

                <div class="page-block">
                    <create-user :form="form" :roles="userRoles" @submit="createUser" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { UsersApi, userMixin } from 'relapp-users';
import { apiMixin } from 'relapp-api';
import { EventBus } from 'relapp-event';
import { CreateUser } from 'relapp-users';
import { Way2Form, formMixin } from 'relapp-way2forms';

export default {
    components: {
        CreateUser
    },
    metaInfo: {
        title: trans('page.users.title')
    },
    mixins: [userMixin, apiMixin, formMixin],
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            form: new Way2Form({
                first_name: null,
                last_name: null,
                email: null,
                role: 'owner'
            })
        };
    },
    methods: {
        /**
         * Call the endpoint to create the user.
         *
         * @param {object} form
         */
        createUser(form) {
            this.startLoading();
            UsersApi.add(form.data())
                .then(() => {
                    this.finishLoading();
                    this.$router.push({ name: 'users' });

                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('user.confirmation.message')
                    });
                })
                .catch(error => {
                    this.showValidationErrors(error, form);
                })
                .then(this.finishLoading);
        }
    }
};
</script>
